import { DOM } from '../shared/helpers/Document';

// Hamburger nav 
(function() {
	const button = DOM.id('app-nav-toggle');
	if(! button ) {
		return;
	}
	
	let isOpen = false;
	//const hamb = button.querySelector('.hamburger');
	const panel = DOM.qs('.app-primary-nav');
	
	
	const _open = () => {
		document.body.classList.add('modal-open');
		document.body.classList.add('primary-nav-shown');
		panel.classList.add('panel-open');
		//hamb.classList.add('is-active');
		button.setAttribute('aria-expanded', true);
		panel.setAttribute('aria-expanded', true);
		isOpen = true;
	};
	
	const _close = () => {
		document.body.classList.remove('modal-open');
		document.body.classList.remove('primary-nav-shown');
		panel.classList.remove('panel-open');
		//hamb.classList.remove('is-active');
		button.setAttribute('aria-expanded', false);
		panel.setAttribute('aria-expanded', false);
		isOpen = false;
	};
	
	button.addEventListener('click', () => {
		if( isOpen ) {
			return _close();
		}
		return _open();
	});
	
	
	const closeButton = DOM.id('primary-nav-panel-close');
	if( closeButton ) {
		closeButton.addEventListener('click', () => {
			return _close();
		});
	}
	
	
	document.addEventListener('navPanelClose', () => _close() );
})();